export const TYPE_AMBIFI_PHONETICS = "ambifi/tts-phonetics";
export const TYPE_AMBIFI_PICKER_DATASOURCE = "ambifi/picker-datasource";
export const TYPE_AMBIFI_PICKER_DATASOURCE_ARRAY = "ambifi/picker-datasource-array";
export const TYPE_AMBIFI_PICKER_DATASOURCE_MAP = "ambifi/picker-datasource-map";
export const TYPE_AMBIFI_PICKER_DATASOURCE_BOTH = "ambifi/picker-datasource-both";
export const TYPE_AMBIFI_THEME = "ambifi/theme";
export const TYPE_AMBIFI_STYLESHEET = "ambifi/stylesheet";
export const TYPE_AMBIFI_PLAYLISTS = "ambifi/playlists";
export const TYPE_AMBIFI_WORKFLOW_STATES = "ambifi/workflow-states";
